import React from "react";
import BasePaginatedDropdown from "./BasePaginatedDropdown";
import { type DropdownWithoutOptionsProps } from "../models";

type Props = DropdownWithoutOptionsProps<server.dto.ICalendarTemplateSmall>;

const ICalFeedTemplatePaginatedDropdown = (props: Props) => {
  const fetchIcalTemplates = async (search: string, page: number) => {
    const res = await window.CoreApi.ICalendarTemplate.List({
      keyword: search,
      page,
      perPage: 10,
      excludeKeys: props.excludeKeys
    });

    return res;
  };

  return <BasePaginatedDropdown
    excludeKeys={props.excludeKeys}

    fetchOptions={fetchIcalTemplates}
    getLabel={c => c.title}
    getValue={c => c.iCalendarTemplateId}

    config={props.config}
    value={props.value}
    onChange={props.onChange}
  />;
};

export default ICalFeedTemplatePaginatedDropdown;